import styled from 'styled-components';

import {ms} from '@yourcoach/shared/styles/normalizeSize';
import {getAlphaColor, getColor} from '@yourcoach/shared/styles/utils';
import {getFontWeight} from '@yourcoach/shared/styles/utils/getFontWeight';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

export const Label = styled(Text)`
  font-weight: ${getFontWeight('semibold')};
  font-size: 0.875rem;
  line-height: ${ms(20)};
  color: ${getColor('text1')};
`;

export const Overlay = styled(View)`
  position: fixed;
  inset: 0;
  background-color: ${getAlphaColor('background.white', 0.7)};
  z-index: 999;
  align-items: center;
  justify-content: center;
`;
